import {SellerDynamic} from "../src/seller/SellerDynamic";
import {prepareHydratedApp} from "./utils/prepare_hydrate_app";

const config = [{reactDynamic: "seller-page", view: <SellerDynamic />}];

(() => prepareHydratedApp(config))();
